<p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{width: '520px'}" (onHide)="cancel()">
    <ng-template pTemplate="header">
        <div class="w-full text-center font-22 font-weight-600">{{title | translate}}
        </div>
    </ng-template>

    <div>
        <form #form="ngForm" (ngSubmit)="onSave()">
                <div class="m-auto">
                    <div class="row form-input-row">
                        <div class="col-5 text-right font-14 pr-0" translate>common.branch<span class="requireSym">*</span></div>
                        <div class="col-7">
                        <p-dropdown [options]="branches" name="branch" id="branch"
                                [(ngModel)]="branchId" [appendTo]="'body'"
                                optionLabel="name" optionValue="id" #branchRef="ngModel" required class="w-full"
                                [style]="{'width': '100%'}">
                            </p-dropdown>

                            <small class="error-message-box">
                                {{branchRef.valid || !submittedForm ? ' ' : 'This field is required'}}
                            </small>
                        </div>
                    </div>

                    <div class="row form-input-row">
                        <div class="col-5 text-right font-14 pr-0" translate>printing_form.title<span class="requireSym">*</span></div>
                        <div class="col-7">
                            <div pTooltip="{{selectedPrintingForm?.name}}" tooltipStyleClass="tooltip-class" tooltipPosition="bottom">
                                <p-dropdown [options]="printingFormsList" name="printingForm" id="printingForm"
                                        [(ngModel)]="selectedPrintingForm" [appendTo]="'body'"
                                        optionLabel="name" #printingForm="ngModel" required class="w-full"
                                        [style]="{'width': '100%'}">
                                </p-dropdown>
                            </div> 
                            <small class="error-message-box">
                                {{printingForm.valid || !submittedForm ? ' ' : 'This field is required'}}
                            </small>
                        </div>
                    </div>
                </div>
    
                <div class="form-input-row pt-40">
                    <div class="d-flex justify-content-center">
                        <app-button id ="print-saving" buttonClass="btn-primary" [isDisabled]="!branchId || !selectedPrintingForm"
                                    buttonType="button" (clickEvent)="onSave()">
                            <span translate>buttons.print</span>
                        </app-button>
                        <app-button id ="download-savings" buttonClass="btn-primary" [isDisabled]="!branchId || !selectedPrintingForm"
                                    buttonType="button" (clickEvent)="onDownload()">
                            <span translate>buttons.download</span>
                        </app-button>
                        <app-button id ="cancel-savings" buttonClass="btn-secondary mr-0"
                                    buttonType="button" (clickEvent)="cancel()">
                            <span translate>buttons.cancel</span>
                        </app-button>

                    </div>
                </div>
        </form>
    </div>
</p-dialog>